import { queryPharmacyLicense } from "./pharmacyLicenseStore";
import { PharmacyLicense } from "./types";

export function normalizeStateCode(state: string | null | undefined): string {
  return (state || "").trim().toUpperCase();
}

/**
 * Null/blank expiration_date means the license does not expire and is valid.
 * Otherwise valid when expiration_date >= asOfDate.
 */
export function isLicenseUnexpired(
  expirationDate: string | null | undefined,
  asOfDate: string
): boolean {
  if (expirationDate == null || String(expirationDate).trim() === "") {
    return true;
  }
  const exp = new Date(expirationDate);
  const asOf = new Date(asOfDate);
  if (isNaN(exp.getTime()) || isNaN(asOf.getTime())) return false;
  return exp >= asOf;
}

/**
 * pharmacy_licenses lookup by pharmacy_id + state.
 * Prefer explicit `rows` (Redux / API); otherwise use the hydrated table.
 */
export function findPharmacyLicense(
  pharmacyId: number,
  state: string,
  rows?: PharmacyLicense[]
): PharmacyLicense | null {
  return queryPharmacyLicense(pharmacyId, state, rows);
}

/**
 * Uses product.compoundType (sterile | non-sterile).
 * Null/empty compoundType is treated as sterile for Gate 1 safety.
 */
export function isSterileCompoundProduct(product: {
  compoundType?: string | null;
}): boolean {
  const type = (product.compoundType || "").trim().toLowerCase().replace(/\s+/g, "-");
  if (type === "non-sterile" || type === "nonsterile") return false;
  if (type === "sterile") return true;
  return true;
}

/**
 * patient_state derivation (used by Prescriber Confirmation UI):
 * - Ship to practice (in-office): patient is at the practice → same as ship-to.
 * - Ship to patient: use patient residency; fall back to ship-to if missing.
 */
export function resolvePatientState(args: {
  shipTo: "clinic" | "patient" | string;
  shipToState: string;
  patientResidencyState?: string | null;
}): string {
  const ship = normalizeStateCode(args.shipToState);
  if (args.shipTo === "clinic") return ship;
  return normalizeStateCode(args.patientResidencyState) || ship;
}

export function todayIsoDate(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
